import type { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  timeLeft?: string;
}

export function MaLiveBadge({ children = "LIVE NOW", timeLeft }: Props) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "4px 8px",
      background: "var(--ma-brick)", color: "var(--ma-paper)",
      fontFamily: "var(--ma-mono)", fontSize: 10,
      letterSpacing: "0.12em", textTransform: "uppercase",
      borderRadius: 2, fontWeight: 600,
    }}>
      <span className="ma-pulse-dot" style={{ background: "var(--ma-paper)" }} />
      {children}
      {timeLeft && <span style={{ opacity: 0.85, marginLeft: 2, fontWeight: 400 }}>{timeLeft}</span>}
    </span>
  );
}
